module.exports = __webpack_public_path__ + "assets/fonts/66e6cf6cd44c2e2be34cc6b3b7dd3325.woff2";